// Lease.ts

export default class Audit {

    timestamp                   : String;
    readable_timestamp          : String;
    level                       : String;
    application_module          : String;
    session_id                  : String;
    remote_address              : String;
    operation_type              : String;
    operation_user              : String;
    operation_info              : string;
    operation_result            : Number;
    readable_operation_result   : String;
    icon_operation_result       : Object;
    object_type                 : String;
    object_id                   : Number;
    object                      : Object;



    constructor(dict = null)
    {
        if (dict !== null)
        {
            this.timestamp               = dict["timestamp"];
            this.readable_timestamp      = dict["readable_timestamp"];
            this.level                   = dict["level"];
            this.application_module      = dict["application_module"];
            this.session_id              = dict["session_id"];
            this.remote_address          = dict["remote_address"];
            this.operation_type          = dict["operation_type"];
            this.operation_user          = dict["operation_user"];
            this.operation_info          = JSON.stringify(dict["operation_info"]);
            this.operation_result        = dict["operation_result"];
            this.readable_operation_result = this.operation_result === 1 ? "generic.success"  : "generic.error";
            this.icon_operation_result   = this.operation_result === 1 ? { "icon" : "check_circle" , "color" : "green"} : { "icon" : "error" , "color" : "red"};
            this.object_type             = dict["object_type"];
            this.object_id               = dict["object_id"];
            this.object                  = dict["object"];
        }
    }


  }
